import React from 'react'
import CommonHeader from '../../component/CommonHeader/CommonHeader'
import Button from '../../component/button/Button';
import style from "./style.module.css"
import { useNavigate } from 'react-router-dom';

const Greate = () => {
    const navigate = useNavigate()
  const handleView = () => {
    // navigate("/file-upload");
      navigate("/mainlayout/media-library");
    }
  return (
    <div>
      <CommonHeader />
      <div className={style.mainContainer}>
        <div className={style.innerContainer}>
          <div className={style.innerTextBox}>
            <div className={style.headingText}>Great! Thanks for joining {process.env.REACT_APP_TITLE}</div>
                      <p className={style.paraText}>
              Now you can begin uploading your content to connect with your
              audience.
            </p>
          </div>
          <div>
            <Button onClick={handleView}>View Account</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Greate